import * as s from "react";
import { b as u, a as f } from "./index-D0iE9LhQ.js";
import { R as l, P as d } from "./index-ClCj2_km.js";
import { jsx as p } from "react/jsx-runtime";
function R(r, e = globalThis == null ? void 0 : globalThis.document) {
  const t = u(r);
  s.useEffect(() => {
    const a = (o) => {
      o.key === "Escape" && t(o);
    };
    return e.addEventListener("keydown", a, { capture: !0 }), () => e.removeEventListener("keydown", a, { capture: !0 });
  }, [t, e]);
}
var m = "Portal", y = s.forwardRef((r, e) => {
  var c;
  const { container: t, ...a } = r, [o, i] = s.useState(!1);
  f(() => i(!0), []);
  const n = t || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return n ? l.createPortal(/* @__PURE__ */ p(d.div, { ...a, ref: e }), n) : null;
});
y.displayName = m;
export {
  y as P,
  R as u
};
